import {gql,TypedDocumentNode} from '@apollo/client';

interface Result {
    id: string,
}

interface Variables {
    input: {
        name: string,
        email: string,
    }
}

export const CREATE_USER: TypedDocumentNode<Result, Variables> = gql`
    mutation CreateUser($input: CreateUserInput!){
        createUser(input: $input) {
            id
        }
    }       
`
